var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sidebar filter" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("form", { staticClass: "sidebar-form ic-form promo-filter" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.maxPrice,
                  expression: "maxPrice",
                },
              ],
              staticClass: "form-range",
              attrs: {
                type: "range",
                min: "0",
                max: "500",
                step: "1",
                id: "customRange3",
              },
              domProps: { value: _vm.maxPrice },
              on: {
                __r: function ($event) {
                  _vm.maxPrice = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "form-label d-flex justify-content-between color-dark-gray",
                attrs: { for: "customRange3" },
              },
              [
                _c("span", [_vm._v("1 zł")]),
                _vm._v(" "),
                _c("span", { staticClass: "max", attrs: { id: "max-price" } }, [
                  _vm._v(_vm._s(_vm.maxPrice) + " zł"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _c("strong", [_vm._v("Filtruj")]),
      _vm._v(" oferty\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-check mb-3" }, [
      _c("input", {
        staticClass: "form-check-input large-checkbox",
        attrs: { type: "checkbox", value: "", id: "flexCheckDefault1" },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "form-check-label",
          attrs: { for: "flexCheckDefault1" },
        },
        [_vm._v("\n            Lorem  dolor sit amet\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-check mb-3" }, [
      _c("input", {
        staticClass: "form-check-input",
        attrs: { type: "checkbox", value: "", id: "flexCheckDefault2" },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "form-check-label",
          attrs: { for: "flexCheckDefault2" },
        },
        [_vm._v("\n            Lorem ipsum dolor sit\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-check mb-3" }, [
      _c("input", {
        staticClass: "form-check-input",
        attrs: { type: "checkbox", value: "", id: "flexCheckDefault3" },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "form-check-label",
          attrs: { for: "flexCheckDefault3" },
        },
        [
          _vm._v(
            "\n            Lorem ipsum dolor sit amet  dolor sit amet\n          "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-check mb-3" }, [
      _c("input", {
        staticClass: "form-check-input",
        attrs: { type: "checkbox", value: "", id: "flexCheckDefault4" },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "form-check-label",
          attrs: { for: "flexCheckDefault4" },
        },
        [_vm._v("\n            Lorem ipsum\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _c("strong", [_vm._v("Przedział")]),
      _vm._v(" cenowy\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }